import { useMutation } from "@apollo/client/react";
import {
  AdminStudyProgrammeFragment,
  CreateExamSyllabus,
  CreateExamSyllabusVariables,
} from "__generated__/types";
import { Section } from "common/components/Section";
import { markdownInput } from "common/input-types";
import {
  ExamSyllabusForm,
  ExamSyllabusFormValues,
} from "domain/admin/exam-syllabus/ExamSyllabusForm";
import gql from "graphql-tag";
import * as React from "react";

const MUTATION = gql`
  mutation CreateExamSyllabus($input: CreateExamSyllabusInput!) {
    createExamSyllabus(input: $input) {
      examSyllabus {
        id
        title
        description {
          content
          isMarkdown
        }
      }
    }
  }
`;

interface Props {
  cancel(): void;
  complete(): void;
  parent?: AdminStudyProgrammeFragment | undefined;
}

export const ExamSyllabusCreate: React.FC<React.PropsWithChildren<Props>> = ({
  cancel,
  complete,
  parent,
}) => {
  const [mutate, { error, loading }] = useMutation<
    CreateExamSyllabus,
    CreateExamSyllabusVariables
  >(MUTATION);

  const onSubmit = async (input: ExamSyllabusFormValues) => {
    const result = await mutate({
      variables: {
        input: {
          studyProgrammeId: input.studyProgramme.value,
          title: input.title,
          description: markdownInput(input.description),
          studyPoints: input.studyPoints,
          examDate: input.examDate,
        },
      },
    });

    if (result.data) {
      complete();
    }
  };

  return (
    <Section title="Nytt pensum">
      <ExamSyllabusForm
        onSubmit={onSubmit}
        onCancel={cancel}
        canPublish={false}
        parent={parent}
        loading={loading}
        error={error}
      />
    </Section>
  );
};
